module.exports = __webpack_public_path__ + "static/vulcan_emoji-2923d07c74cad11ccc08781fb206899c.svg";